export default "__VITE_ASSET__52Mo9pn___"